import { store } from 'redux/store';

import { Partner, Society } from 'types';

import { saveDocumentTags } from 'modules/documents/api/saveDocumentTags';

type SaveSharesOwnershipCertificateProps = {
  partner: Partner | null;
  society: Society;
};

type LanguageMap = {
  [key: string]: string | undefined;
};

const getSharesOwnershipCertificateDocumentId = (
  society: Society,
  partner: Partner | null
) => {
  const partnerLanguage = partner?.language || 'es';

  const languageMap: LanguageMap = {
    es: society?.templates?.sharesOwnershipCertificateES,
    cat: society?.templates?.sharesOwnershipCertificateCA,
  };

  return languageMap[partnerLanguage];
};

const getSharesOwnershipCertificateFooterDocumentId = (society: Society) =>
  society?.templates?.sharesOwnershipCertificateFooter;

const getPartnerId = (partner: Partner | null) => partner?.['_id'];

const getDocumentIds = (society: Society, partner: Partner | null) => {
  const sharesOwnershipCertificateDocumentId =
    getSharesOwnershipCertificateDocumentId(society, partner);
  const sharesOwnershipCertificateFooterDocumentId =
    getSharesOwnershipCertificateFooterDocumentId(society);

  return {
    sharesOwnershipCertificateDocumentId,
    sharesOwnershipCertificateFooterDocumentId,
  };
};

export const saveSharesOwnershipCertificate = async ({
  partner,
  society,
}: SaveSharesOwnershipCertificateProps) => {
  const { sharesOwnershipCertificateDocumentId } = getDocumentIds(
    society,
    partner
  );

  const partnerId = getPartnerId(partner);

  const sources = {
    partner: partnerId,
    society: society?._id,
    allPartners: true,
  };

  if (!sharesOwnershipCertificateDocumentId) {
    return;
  }

  const result = await store.dispatch(
    saveDocumentTags({
      documentId: sharesOwnershipCertificateDocumentId,
      sources,
      language: partner?.language || 'es',
    })
  );
};
